import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import VueCookies from 'vue-cookies'

Vue.config.productionTip = false

Vue.use(VueCookies)

new Vue({
  icons: {
    iconfont: 'mdi', // default - only for display purposes
  },
  router,
  store,
  render: h => h(App),
}).$mount('#app')
